import React from 'react'
import { DOWNLOAD_RED_SVG, RED_NOTE_SVG, SOCIAL_BLACK_FB, SOCIAL_BLACK_LINKEDIN, SOCIAL_BLACK_TWITTER, SOCIAL_EMAIL, SOCIAL_LINK } from "bpm-sounds-generic/assets"
import { Button } from 'bpm-sounds-generic'
import {
    FacebookShareButton,
    TwitterShareButton,
    LinkedinShareButton,
    EmailShareButton,
} from "react-share";
import { useHistory } from 'react-router';
import { Contest } from '../../api/models/contest';
import { shareLink } from 'bpm-sounds-generic';
import { ContestAPI } from '../../api/endpoints/contest';

interface HeaderProps {
    contest: Contest
}

const Header = (props: HeaderProps) => {
    const { artwork_url, title, artwork_gradient_colors, zip_url, submission_deadline } = props.contest
    const shareUrl = window.location.href
    const history = useHistory()

    let style: React.CSSProperties = {}
    if (artwork_gradient_colors) {
        const top_1 = 'black'
        const top_2 = artwork_gradient_colors.split(', ')[0]
        const top_3 = artwork_gradient_colors.split(', ')[1]
        const background =
            `linear-gradient(-90deg, ${top_1} 0%, ${top_2} 50%, ${top_3} 100%)`
        style = ({ background: background })
    }
    return (
        <div className="Contest-Header" style={style}>
            <img className="artwork" src={artwork_url} alt="" />
            <div className="right-content">
                <div className="title">{title}</div>
                <div className="big-buttons">
                    <Button buttonText="Download Stems" backgroundColor="#fff" image={DOWNLOAD_RED_SVG} imgWidth={'25px'} fontSize={'16px'} textColor={'#1A1A1A'}
                        onClick={() => {
                            ContestAPI.recordDownloadStems(props.contest.id).catch(() => {

                            })
                            window.open(zip_url, "_blank")
                        }} />
                    <Button disabled={new Date(submission_deadline).getTime() < (new Date()).getTime()}
                        buttonText="Enter Now" backgroundColor="#fff" image={RED_NOTE_SVG}
                        imgWidth={'22px'} fontSize={'16px'} textColor={'#1A1A1A'}
                        onClick={() => history.push(`/contest/submit?${props.contest.slug}`)} />
                </div>
                <div className="share-container">
                    <span className="share-text">Share:</span>
                    <FacebookShareButton
                        url={shareUrl}
                        quote={'BPM Create: ' + title}
                        className="share-button fb"
                    >
                        <img src={SOCIAL_BLACK_FB} alt="facebook" />
                    </FacebookShareButton>

                    <TwitterShareButton
                        url={shareUrl}
                        title={'BPM Create: ' + title}
                        className="share-button twitter"
                    >
                        <img src={SOCIAL_BLACK_TWITTER} alt="twitter" />
                    </TwitterShareButton>

                    <LinkedinShareButton
                        url={shareUrl}
                        title={'BPM Create: ' + title}
                        className="share-button linkedin"
                    >
                        <img src={SOCIAL_BLACK_LINKEDIN} alt="linkedin" />
                    </LinkedinShareButton>
                    <EmailShareButton
                        url={shareUrl}
                        subject={'BPM Create: ' + title}
                        body={'Check out this contest on BPMCreate: '}
                        className="share-button email"
                    >
                        <img src={SOCIAL_EMAIL} alt="facebook" />
                    </EmailShareButton>
                    <button className="share-button link" onClick={() => {
                        shareLink(window.location.href);
                    }}>
                        <img src={SOCIAL_LINK} alt="facebook" />
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Header